import type { McpConnection } from '@easyhelp/shared';

/** Nome del client come l'ha dichiarato al collegamento, o un segnaposto se non l'ha dato. */
export function clientName(connection: McpConnection): string {
  return connection.client.name?.trim() || 'Client senza nome';
}

/**
 * Da dove si è collegato il client, il dato verificato (il nome no), come nella schermata di
 * consenso: un sito (`claude.ai`), un'app (`cursor://…`) o un programma locale (Claude Code, Cursor).
 */
export function clientOrigin({ client }: McpConnection): string {
  switch (client.redirectKind) {
    case 'web':
      return client.redirectTarget;
    case 'app':
      return `app ${client.redirectTarget}`;
    case 'locale':
      return `programma locale (${client.redirectTarget})`;
  }
}
